<template>
  <div class="flex flex-col justify-center items-center space-y-6">
    <dashboard-number-box :class="closingRateBgColor"> {{ closingRateRounded }}% </dashboard-number-box>
    <div class="my-2">
      <p class="text-primary font-medium text-2xl font-montserrat">Campaigns Closing Rate</p>
      <p class="h-20 mt-2">
        {{ closingRateText }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    closingRate: {
      type: Number,
      require: true,
      default: 0,
    },
  },
  computed: {
    closingRateRounded() {
      return Math.round(this.closingRate);
    },
    closingRateBgColor() {
      if (this.closingRate < 60) {
        return 'bg-red-700';
      }

      if (this.closingRate < 90) {
        return 'bg-warning';
      }

      return 'bg-success';
    },
    closingRateText() {
      if (this.closingRate < 60) {
        return `Attention, your campaign closing rate is very low. Check your active campaigns and reach us out via campaign chat if you have any issues.`;
      }

      if (this.closingRate < 90) {
        return `Your campaign closing rate is dropping. Check your active campaigns that need your attention!`;
      }

      return `Congratulations! Your campaign closing rate is excellent. Thank you for your hard work and professionalism.`;
    },
  },
};
</script>

<style></style>
